module.exports = __webpack_public_path__ + "47683090eda055fe809569e2282ba0f3.pdf";